import * as React from 'react';
import { observer } from 'mobx-react';
import { FormState, FieldState } from 'formstate';

// Constants
import {} from '../../constants/routes';

// Services
import { validateEmail } from 'services/auth';

// Components
import { Form, TextField } from '../../components/FormStateFields';
import Typography from '../../components/Typography';

// Utilities
import { required, email, between } from '../../utilities/validation';

// Helpers
function checkEmail(value: string): Promise<string | null> {
  return new Promise(resolve => {
    validateEmail({
      body: {
        email: value
      }
    }).then(res => {
      if (res.exist) {
        resolve('Already in use');
      } else {
        resolve(null);
      }
    });
  });
}

// Form
class AccountFormState {
  // Create a field
  email = new FieldState('')
    .disableAutoValidation()
    .validators(required, between(5, 100), email, checkEmail);
  password = new FieldState('')
    .disableAutoValidation()
    .validators(required, between(4, 32));

  // Compose fields into a form
  state = new FormState({
    email: this.email,
    password: this.password
  });

  getValues() {
    return {
      email: this.email.$,
      password: this.password.$
    };
  }
}

// Component
export interface IProps {
  formState: AccountFormState;
  onSubmit: React.EventHandler<React.FormEvent<HTMLFormElement>>;
}
function AccountStep({ formState, onSubmit }: IProps) {
  return (
    <Form onSubmit={onSubmit}>
      <Typography type="headline">Account details</Typography>
      <Typography type="subheading" color="textSecondary">
        Enter your login information
      </Typography>
      <TextField
        label="Email"
        type="text"
        required={true}
        fieldState={formState.email}
        margin="normal"
        fullWidth={true}
      />
      <TextField
        label="Password"
        type="password"
        required={true}
        fieldState={formState.password}
        margin="normal"
        fullWidth={true}
      />
      <button style={{ opacity: 0, position: 'absolute' }} type="submit" />
    </Form>
  );
}

export { AccountFormState };
export default observer(AccountStep);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/SignUp/AccountStep.tsx